import {
  Box,
  ButtonBase,
  Typography,
  MenuItem,
  Select,
  FormControl,
  IconButton,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";
import primaryBg from "../../assets/modules/photo_2025-09-24_10-09-27.jpg";
import Footer from "../home/Footer";
import logo from "../../assets/icons/logo-blog.png";

import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const About = () => {
  const [modules, setModules] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("primary");
  const [category, setCategory] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getData } = useAuth();
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getData("proccess.php", "modules_V2"); // Fetch adverts data
        if (response.success) {
          const sortedModules = [...response.data].sort((a, b) => {
            const orderA = Number(a.listing_Order) || 0;
            const orderB = Number(b.listing_Order) || 0;
            return orderA - orderB;
          });
          setModules(sortedModules);
        } else {
          console.error(response.message || "Failed to load Modules");
        }

        const cate = await getData("proccess.php", "our_clients_V2"); // Fetch adverts data
        if (cate.success) {
          setCategory(cate.data);
        } else {
          console.error(cate.message || "Failed to load Modules");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]); // Added dependency array

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  // Filter modules based on selected category and search term
  const filteredModules = modules.filter(
    (module) =>
      module.categories === selectedCategory &&
      (module.module_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        module.short_description
          .toLowerCase()
          .includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="parentContainer">
      <Box
        position={"relative"}
        minHeight={"50vh"}
        width={"100%"}
        sx={{
          backgroundColor: "#ffffffff",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          zIndex: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          maxWidth={"1200px"}
          sx={{
            width: "100%",
            minHeight: "50vh",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 2,
            marginTop: "100px",
            marginBottom: "50px",
            padding: "1rem",
          }}
        >
          <Box
            sx={{
              flex: 1,
              minWidth: "300px",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
              position: "relative",
              zIndex: 100,
            }}
          >
            <h1 className="primary-header" style={{ color: "#000000ff" }}>
              About Our Modules
            </h1>
            <p
              style={{
                color: "#000000ff",
                textAlign: "start",
                marginTop: "2rem",
                fontSize: "1.3rem",
              }}
            >
              Our modules are thoughtfully designed to promote innovation, critical thinking, and practical problem-solving through hands-on, experiential learning. Each module integrates elements of Science, Technology, Engineering, Arts, and Mathematics (STEAM) to equip learners with essential 21st-century skills.
              <br></br><br></br>
              Our curriculum covers diverse focus areas,  ensuring that every student gains exposure to both technical knowledge and creative application. By blending theory with practice, our modules prepare students to adapt, innovate, and contribute meaningfully in a rapidly evolving world.
            </p>
          </Box>
          <Box
            sx={{
              flex: 1,
              minWidth: "300px",
              maxWidth: "600px",
              maxHeight: "350px",
              overflow: "hidden",
              borderRadius: "1rem",
            }}
          >
            {primaryBg && (
              <img
                src={`${primaryBg}`}
                style={{
                  width: "100%",
                }}
                alt="About our modules"
              />
            )}
          </Box>
        </Box>
      </Box>

      <Box
        width={"100%"}
        height={"auto"}
        sx={{
          backgroundColor: "#e7f1f5",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          width={"100%"}
          maxWidth={"1200px"}
          height={"auto"}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
          }}
        >
          <Box
            sx={{
              background: "#bdbfddff",
              width: "100%",
              margin: "1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: { xs: "none", sm: "none", md: "block" },
              }}
            >
              {category.length > 0 &&
                category.map((cat) => (
                  <ButtonBase
                    key={cat.id}
                    onClick={() => setSelectedCategory(cat.categories)}
                    sx={{
                      backgroundColor:
                        cat.categories === selectedCategory
                          ? "#3b76b2"
                          : "transparent",
                      padding: "1rem",
                      color:
                        cat.categories === selectedCategory
                          ? "#ffffffff"
                          : "#3b76b2",
                      fontSize: "1rem",
                      fontWeight: "700",
                    }}
                  >
                    {cat.title}
                  </ButtonBase>
                ))}
            </Box>

            {/* Mobile dropdown */}
            <Box
              sx={{
                display: { xs: "block", sm: "block", md: "none" },
                padding: "1rem",
              }}
            >
              <FormControl variant="standard">
                <Select
                  labelId="categories-label"
                  id="categories"
                  value={selectedCategory}
                  label="Categories"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  variant="standard"
                >
                  {category.length > 0 &&
                    category.map((cat) => (
                      <MenuItem key={cat.categories} value={cat.categories}>
                        {cat.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>

            {/* Search */}
            <Box
              sx={{
                backgroundColor: "#fdfdfdff",
                width: "250px",
                height: "auto",
                borderRadius: "1rem",
                marginRight: "1rem",
                display: "flex",
                alignItems: "center",
                paddingRight: ".5rem",
                color: "#fff",
              }}
            >
              <input
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  width: "100%",
                  padding: ".5rem",
                }}
                type="search"
                placeholder="Search by categories"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <SearchIcon />
            </Box>
          </Box>

          {/* Modules Section with Scroll Controls */}
          <Box
            width={"100%"}
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              margin: "1rem 0",
            }}
          >
            {/* Left Scroll Button */}
            <IconButton
              onClick={scrollLeft}
              sx={{
                position: "absolute",
                left: -20,
                zIndex: 10,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                },
                display: { xs: "none", sm: "flex" },
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            {/* Modules Container */}
            <Box
              ref={scrollContainerRef}
              sx={{
                display: "flex",
                overflowX: "auto",
                gap: "1rem",
                padding: "1rem 0.5rem",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                width: "100%",
              }}
            >
              {filteredModules.length > 0 ? (
                filteredModules.map((module) => (
                  <Box
                    key={module.id}
                    sx={{
                      flex: "0 0 auto",
                      width: 'auto',
                      height: "auto",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: "#3b76b2",
                        borderRadius: "1rem",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        <Box display={'flex'} justifyContent={'space-between'}>
                          <Link
                            to={`/modules/${module.categories}/?code=${module.id}`}
                          >
                            <ButtonBase
                              sx={{
                                background: "linear-gradient(to right, #3b76b2 ,#32a059)",
                                color: '#fff',
                                padding: "1rem",
                                borderRadius: "1rem",
                              }}
                            >
                              {module.module_name}
                            </ButtonBase>
                          </Link>
                        </Box>
                        
                      </Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "2rem",
                  }}
                >
                  <Typography variant="h6">
                    No modules found matching the criteria.
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Right Scroll Button */}
            <IconButton
              onClick={scrollRight}
              sx={{
                position: "absolute",
                right: -20,
                zIndex: 10,
                backgroundColor: "rgba(255, 255, 255, 0.8)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 1)",
                },
                display: { xs: "none", sm: "flex" },
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;
